import React from 'react';
import IconGallery from './IconGallery';

export default {
  title: 'Components/Icons/IconGallery',
  component: IconGallery,
  parameters: {
    layout: 'fullscreen',
    backgrounds: {
      default: 'gray',
      values: [
        { name: 'gray', value: '#d1d5db' },
      ],
    },
  },
  tags: ['autodocs'],
  argTypes: {
    iconSet: {
      description: 'The set of icons to display in the gallery. Options are:\n- `iconsDictionary` for icons from svg files (Icon.js).\n- `customIconsDictionary` for icons from svg code (Icons.js).\n- `iconsList` for icons from @mdi/js (iconsList.js).\n- `navbarIcons` for icons from react-icons/md (Navbar.js).',
      control: { type: 'select' },
      options: ['iconsDictionary', 'customIconsDictionary', 'iconsList', 'navbarIcons'],
      defaultValue: 'iconsDictionary',
    },
  },
};

// Template for creating stories
const Template = (args) => <IconGallery {...args} />;

// Story for icons from Icon.js
export const IconsFromSvgFiles = Template.bind({});
IconsFromSvgFiles.args = {
  iconSet: 'iconsDictionary',
};

// Story for icons from Icons.js
export const IconsFromSvgCode = Template.bind({});
IconsFromSvgCode.args = {
  iconSet: 'customIconsDictionary',
};

// Story for icons from iconsList.js
export const IconsFromMdiJs = Template.bind({});
IconsFromMdiJs.args = {
  iconSet: 'iconsList',
};

// Story for icons from Navbar.js
export const IconsFromReactIcons = Template.bind({});
IconsFromReactIcons.args = {
  iconSet: 'navbarIcons',
};
